import { pxToRem } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Container = styled.div `
  // cancel out the ckeditor padding
  margin: 0 -${pxToRem(9.6)};
  width: calc(100% - ${pxToRem(9.6 * 2)});
`;
